/* Application environment
   ========================================================================== */

var app = {
	},
	template = {
		component: {},
		util: {}
	};

/* Define jQuery in noConflict mode */
$ = jQuery.noConflict();
